(function () {
  if (window.__nestPdpVariantKeyboardFocus20260723) return;
  window.__nestPdpVariantKeyboardFocus20260723 = 'v3-single-selector-owner';
  var sequence = 0;
  function clean(value) { return (value || '').replace(/\s+/g, ' ').trim(); }
  function set(el, name, value) { if (el.getAttribute(name) !== value) el.setAttribute(name, value); }
  function visible(el) { return !!(el && el.getClientRects().length && getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden'); }
  function parts(control) {
    var wrapper = control && control.closest('.select');
    var select = wrapper && wrapper.querySelector('select');
    var list = wrapper && wrapper.querySelector('ul.options');
    return select && list ? { control: control, select: select, list: list, wrapper: wrapper } : null;
  }
  function name(select) {
    var label = select.getAttribute('data-option-label') || select.getAttribute('aria-label');
    if (!label) {
      var description = select.getAttribute('toolparamdescription') || '';
      var match = description.match(/^Select the (.+) option\.$/);
      label = match && match[1];
    }
    if (!label) label = (select.getAttribute('title') || '').replace(/^Select\s+/i, '');
    return clean(label) || 'Product option';
  }
  function sync(control) {
    var p = parts(control); if (!p) return;
    var label = name(p.select);
    var selected = p.select.options[p.select.selectedIndex];
    set(p.select, 'aria-hidden', 'true'); set(p.select, 'tabindex', '-1');
    set(control, 'role', 'button');
    set(control, 'aria-haspopup', 'listbox');
    set(control, 'aria-label', label + ': ' + clean(selected && selected.textContent));
    set(control, 'aria-expanded', visible(p.list) ? 'true' : 'false');
    if (!p.list.id) p.list.id = 'nest-option-list-' + (++sequence);
    set(control, 'aria-controls', p.list.id);
    set(p.list, 'role', 'listbox'); set(p.list, 'aria-label', label);
    Array.prototype.forEach.call(p.list.children, function (option) {
      set(option, 'role', 'option');
      var price = option.querySelector('.variant-price.unavailable') || option.querySelector('.option-sale, .option-price');
      set(option, 'aria-label', clean(option.getAttribute('rel')) + (price && clean(price.textContent) ? ', ' + clean(price.textContent) : ''));
      set(option, 'aria-selected', option.getAttribute('rel') === p.select.value ? 'true' : 'false');
    });
    if (!p.wrapper.__nestOptionObserver) {
      p.wrapper.__nestOptionObserver = new MutationObserver(function () { sync(control); });
      p.wrapper.__nestOptionObserver.observe(p.wrapper, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style', 'class'] });
    }
  }
  function syncAll() { document.querySelectorAll('.styledSelect[tabindex]').forEach(sync); }
  window.nestSyncOptionAccessibility = syncAll;
  function close(p, restore) {
    p.list.style.display = 'none'; p.control.classList.remove('active'); sync(p.control);
    if (restore) p.control.focus({ preventScroll: true });
  }
  window.addEventListener('keydown', function (event) {
    var control = event.target.closest && event.target.closest('.styledSelect[tabindex]');
    var option = event.target.closest && event.target.closest('ul.options > li');
    var p = parts(control || (option && option.closest('.select').querySelector('.styledSelect')));
    if (!p) return;
    var key = event.key;
    if (key === 'Tab') {
      if (!p.wrapper.contains(event.relatedTarget) && visible(p.list)) {
        if (option) p.control.focus({ preventScroll: true });
        close(p, false);
      }
      return;
    }
    if (['Enter', ' ', 'Spacebar', 'Escape', 'ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(key) < 0) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (key === 'Escape') { close(p, true); return; }
    if (option && (key === 'Enter' || key === ' ' || key === 'Spacebar')) {
      option.click(); close(p, true); return;
    }
    if (control && (key === 'Enter' || key === ' ' || key === 'Spacebar')) {
      control.click(); sync(control);
      if (visible(p.list)) {
        var selectedOption = Array.prototype.find.call(p.list.children, function (item) { return item.getAttribute('rel') === p.select.value && visible(item); });
        if (selectedOption) selectedOption.focus();
      }
      return;
    }
    if (!visible(p.list)) p.control.click();
    var options = Array.prototype.filter.call(p.list.children, visible);
    if (!options.length) return;
    var index = options.indexOf(option);
    index = key === 'Home' ? 0 : key === 'End' ? options.length - 1 : key === 'ArrowUp' ? (index <= 0 ? options.length - 1 : index - 1) : (index + 1) % options.length;
    options[index].focus(); sync(p.control);
  }, true);
  document.addEventListener('click', function (event) {
    var option = event.target.closest && event.target.closest('ul.options > li');
    if (option) {
      var p = parts(option.closest('.select').querySelector('.styledSelect'));
      if (p) setTimeout(function () { close(p, document.activeElement === option); }, 0);
    }
    setTimeout(syncAll, 0);
  }, true);
  document.addEventListener('change', syncAll, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll); else syncAll();
})();
